/**
 * Scripts that are tightly coupled to the cart template
 *
 * Compiles to ./dist/assets/scripts/template.cart.js
 */

/* eslint no-console: 0 */
console.log('sucessfully added template.cart.js scripts');
console.warn(
  '***** IMPORTANT *****',
  "if not using this file make sure to set the variable 'include_cart_scripts' to false",
  'located inside ./dist/snippets/asset-router.js'
);
